import { IUserRepository } from '../repositories/IUserRepository'

export interface IValidateEmailByCode {
  execute(email: string, code: string): Promise<void>
}

export default class ValidateEmailByCodeImpl implements IValidateEmailByCode {
  constructor(private readonly userRepository: IUserRepository) {
    // do nothing
  }

  public async execute(email: string, code: string): Promise<void> {
    await this.userRepository.validateEmailCode(email, code)
  }
}
